import { useMemo } from 'react';
import { ANALYTICS_COLORS } from 'constants/colors';
import type { AnalyticsTooltipEntry } from 'actions/analyticActions';

interface DonutReason {
  name: string;
  value: number;
  data?: AnalyticsTooltipEntry[];
}

export const useDonutData = (reasons: DonutReason[]) =>
  useMemo(() => {
    const { labels, data } = reasons.reduce(
      (p, o) => ({
        labels: [...p.labels, o.name],
        data: [...p.data, o.value],
      }),
      { labels: [] as string[], data: [] as number[] }
    );
    return {
      labels,
      datasets: [
        {
          data,
          backgroundColor: ANALYTICS_COLORS,
          borderWidth: 0,
        },
      ],
    };
  }, [reasons]);
